// extracted by mini-css-extract-plugin
module.exports = {"overlay":"styles_overlay__2qOmZ"};